// RU-PREVIEWGATE2 (PG2-4): a new deploy reaches open tabs and the installed PWA.
// The service worker activates a new version at once (skipWaiting + clientsClaim); this module tells the
// page about it. It never reloads on its own: a persistent toast offers "Reload", so an open confirm
// panel is never lost and no reload loop is possible.

export const UPDATE_CHECK_MS = 60 * 60 * 1000;

// onUpdate (serviceWorkerRegistration): a new worker is installed and waiting → let it take over now.
export function activateWaiting(registration) {
  const waiting = registration && registration.waiting;
  if (waiting) waiting.postMessage({ type: "SKIP_WAITING" });
}

// onRegistered: look for a new version when the tab comes back into view, and hourly.
export function scheduleUpdateChecks(registration, { doc = document, setIntervalFn = setInterval } = {}) {
  const check = () => { try { registration.update().catch(() => {}); } catch { /* offline */ } };
  doc.addEventListener("visibilitychange", () => { if (doc.visibilityState === "visible") check(); });
  return setIntervalFn(check, UPDATE_CHECK_MS);
}

// controllerchange after a previous controller existed = a new version now controls this tab.
// The first install (no previous controller) is not an update.
export function watchForNewVersion(sw, notify) {
  if (!sw) return;
  let hadController = !!sw.controller;
  let notified = false;
  sw.addEventListener("controllerchange", () => {
    if (!hadController) { hadController = true; return; }
    if (notified) return;
    notified = true;
    notify();
  });
}

export function showReloadToast(toast, reload = () => window.location.reload()) {
  toast("New version available", {
    id: "sw-update",
    duration: Infinity,
    description: "Reload to use it (finish any open order first).",
    action: { label: "Reload", onClick: () => reload() },
  });
}
